import React, { useState, useEffect } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import InvoiceHeader from '../layout/invoice/InvoiceHeader'
import InvoiceAddress from '../layout/invoice/InvoiceAddress'
import { Link, useParams } from 'react-router-dom';
import InvoiceTable from '../layout/invoice/InvoiceTable'
import { INVOICES_ORDER_DETAILS, COMPANY_DETAILS } from '../../../data/url'
import httpClient from '../../../http/HttpRequest'
import { useTranslation } from 'react-i18next';
import { useReactToPrint } from 'react-to-print';
import { generatePDF } from '../../pdf/GeneratePDF'


export default function ViewInvoice() {

     const [order, setOrder] = useState({});
     const [details, setOrderDetails] = useState([]);
     const [company, setCompanyDetails] = useState({});
     const [customer, setCustomer] = useState({});
     const { t } = useTranslation();

     const { id } = useParams();

     const componentRef = React.useRef();

     const handlePrint = useReactToPrint({
          content: () => componentRef.current,
     });

     useEffect(() => {
          getOrderDetails();
          getCompanyDetails();
     }, []);


     const getOrderDetails = async (e) => {
          const res = await httpClient.post(INVOICES_ORDER_DETAILS, { invoice_id: id });
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    setOrder(result.data.invoice_order);
                    setOrderDetails(result.data.details);
                    setCustomer(result.data.customer);
               }
          }
     }

     const getCompanyDetails = async () => {
          const res = await httpClient.post(COMPANY_DETAILS, {});
          if (res.requestStatus === 'OK') {
               const result = res.result;
               if (result.status === 1) {
                    setCompanyDetails(result.data);

               }
          };
     }

     const makePdf = () => {
          let filename = `${order.invoice_number}-INVOICE`;
          generatePDF(filename);          
     };

     return (
          <AdminLayout>
               <div className="content-wrapper">
                    <ContentHeader title="invoice" subTitle="invoices" subTitleLink="root/invoices" />
                    <div className="card col-md-11 m-auto" id="invoice">
                         <div className="card-body" id="print_section" ref={componentRef}>
                              <InvoiceHeader title="invoice" number={`${order.prefix}-${order.invoice_number}`} />
                              <InvoiceAddress title="bill_to" customer={customer} company={company} order={order} />
                              <InvoiceTable title="bill_to" products={details} order={order} company={company} customer={customer} />
                         </div>
                         <div className='text-center'>
                              <Link to={`/root/invoices/edit/${id}`} type="button" className="btn btn-sm btn-primary btn-icon-text m-1">
                                   {t('edit')}
                              </Link>
                              <button className="btn btn-sm btn-danger btn-icon-text m-1" onClick={makePdf}>{t('pdf')}</button>
                              <button className="btn btn-sm btn-info btn-icon-text m-1" onClick={handlePrint}>{t('print')}</button>
                         </div>
                    </div>
               </div>
          </AdminLayout>
     )
}
